import React from "react";
import { createRoot } from "react-dom/client";
import Progress from "./Progress.jsx";

// A custom web element that wraps the jsx Progress component
class ProgressBar extends HTMLElement {
	connectedCallback() {
		const stage = parseInt(this.getAttribute("stage"), 10);
		const progress = parseFloat(this.getAttribute("progress"));

		const root = createRoot(this);
		root.render(<Progress stage={stage} progress={progress} />);
	}
}

customElements.define("progress-bar", ProgressBar);
